module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl like_or_bad_button_common good_contain",
    class: {
      contain_click: _vm.item.user_helpful_status != 0
    }
  }, [_c('div', {
    staticClass: "fabulous_hand_common",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.useFulAndunUseFul(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      good_click: _vm.item.user_helpful_status != 0
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("toFixed")(_vm.item.total_helpful_num == 0 ? '赞' : _vm.item.total_helpful_num)))])]), _vm._v(" "), (_vm.errobj.type) ? _c('popup', {
    attrs: {
      "pop-obj": _vm.errobj
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2556e4b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/good.vue
// module id = 214
// module chunks = 3